import React, { useState, useEffect } from 'react';
import { Skeleton, Typography } from '@mui/material';
import { getDoc } from 'firebase/firestore';

const ViewSupplier = ({ supplierRef }) => {
  const [supplierData, setSupplierData] = useState(null);
  // const supplierDocRef = doc(db, 'suppliers', supplierId);
  // const supplierDocRef = getDoc(supplierRef);
  // const [supplierData, loading] = useDocumentData(supplierRef ?? null);
  useEffect(() => {
    // console.log(supplierRef);
    const fetchSupplier = async () => {
      const supplierSnap = await getDoc(supplierRef);
      // console.log(supplierSnap.data());
      if (supplierSnap.exists()) {
        setSupplierData(supplierSnap.data());
      }
    };
    if (supplierRef !== undefined || supplierRef === '') {
      fetchSupplier().then();
    }
  }, [supplierRef]);
  if (!supplierData && supplierRef.id)
    return (
      <Skeleton
        variant={'text'}
        height={24}
        animation={'wave'}
      />
    );
  if (supplierData) return <Typography variant={'inherit'}>{supplierData?.name}</Typography>;
};

export default ViewSupplier;
